// import { zipObject, map, mapValues } from 'lodash';
import zipObject from 'lodash/zipObject';
import map from 'lodash/map';
import mapValues from 'lodash/mapValues';
// import orderBy from ''
import uniqueId from 'uniqueid';

// Create actions that don't need constants :)
export const createActions = actionObj => {
  const baseId = uniqueId();
  const actions = map(actionObj, (actionCreator, key) => {
    const actionId = `${baseId}-${key}`;
    const asyncTypes = ['BEGIN', 'SUCCESS', 'FAILURE'].map(
      state => `${actionId}-${state}`,
    );
    const method = (...args) => {
      const result = actionCreator(...args);

      if (result instanceof Promise) {
        return {
          types: asyncTypes,
          promise: result,
          args: args,
        };
      } else if (typeof result === 'function') {
        // Function (async)
        return (...args) => {
          return {
            type: actionId,
            ...(result(...args) || {}),
          };
        };
      } else if (typeof result === 'object') {
        // Object (sync)
        return {
          type: actionId,
          ...(result || {}),
        };
      } else {
        // result null/undefined
        return null;
      }
    };

    if (actionCreator._async === true) {
      const [begin, success, failure] = asyncTypes;
      method._id = {
        begin,
        success,
        failure,
      };
    } else {
      method._id = actionId;
    }

    return [key, method];
  });
  // TODO: MAKE THIS MORE EFFICIENT
  return zipObject(actions.map((i) => i[0]), actions.map((i) => i[1]));
};

// Get action ids from actions created with `createActions`
export const getActionIds = actionCreators => {
  return mapValues(actionCreators, (value, key) => {
    return value._id;
  });
};

// Replace switch statements in stores (taken from the Redux README)
export const createStore = (initialState, handlers) => {
  return (state = initialState, action = {}) => {
    // if (action.type == '*') return handlers[action.type](state, action);
    if (handlers.hasOwnProperty('*')) {
      state = handlers['*'](state, action);
    }

    return handlers[action.type] ? handlers[action.type](state, action) : state;
  };
};

export function promiseMiddleware() {
  return next => action => {
    const { promise, types, ...rest } = action;
    if (!promise) {
      return next(action);
    }

    const [REQUEST, SUCCESS, FAILURE] = types;
    next({ ...rest, type: REQUEST });
    return promise.then(
      result => next({ ...rest, result, type: SUCCESS }),
      error => next({ ...rest, error, type: FAILURE }),
    );
  };
}

export function asyncAction() {
  return (target, name, descriptor) => {
    descriptor.value._async = true;
    return descriptor;
  };
}



// WEBPACK FOOTER //
// ./src/helpers/redux.js